import { IExample } from "../../../Components/Examples.Types";

import HeaderBasicExample from "./examples/Header.Basic.Example";
import HeaderWithBackButtonExample from "./examples/Header.WithBackButton.Example";
import HeaderAdvancedExample from "./examples/Header.Advanced.Example";

export default [
    {
        title: "Basic header",
        component: HeaderBasicExample,
        code: require("!raw-loader!./examples/Header.Basic.Example.tsx"),
        dependencies: {
            "HeaderData.ts": require("!raw-loader!./examples/HeaderData.ts")
        },
        stretchContainer: true
    },
    {
        title: "Header with back button",
        component: HeaderWithBackButtonExample,
        code: require("!raw-loader!./examples/Header.WithBackButton.Example.tsx"),
        stretchContainer: true
    },
    {
        title: "Advanced header",
        component: HeaderAdvancedExample,
        code: require("!raw-loader!./examples/Header.Advanced.Example.tsx"),
        dependencies: {
            "HeaderData.ts": require("!raw-loader!./examples/HeaderData.ts"),
            "Header.Example.css": require("!raw-loader!./examples/Header.Example.css")
        },
        stretchContainer: true
    }
] as IExample[];
